import { toUrlString } from '@libs/algolia';

import { type ProductData } from '../api/base';

export const getSeoData = (
    product: ProductData
): {
    title: string;
    description: string;
    canonicalUrl: string;
} => {
    const categoryHierarchy = product?.categories.reduce(
        (acc: string, category: string) => `${acc}/${toUrlString(category)}`,
        ''
    );

    const productName = product.variants[product.defaultSku].name;
    const productUrl = `${categoryHierarchy}/${toUrlString(productName)}-${product.webStyleId}.html`;

    return {
        title: productName,
        description: `Buy ${productName} at PetSmart`,
        canonicalUrl: productUrl,
    };
};
